import React, { Component } from 'react';

import Grid from '@material-ui/core/Grid';
import MenuItem from '@material-ui/core/MenuItem';

import ChartMenu from './../ChartMenu/ChartMenu';
import BarsComponent from './BarsComponent';

import { colors, colors1, colors2, colors3, colors4, colors5 } from '../../../../constants//icons/characteristics/Characteristics';

class CleanBarComponent extends Component {

  constructor(props) {
    super(props);
    this.state = {
      data: props.data,
      range: 0,
      characteristic: 0,
      colors: colors5,
      dataKey: 'value',
      lineKey: 'medVal',
      title: 'Fenomeno por Comunas',
    }
  }

  componentDidUpdate(prevProps, prevState) {
    // only update chart if the data has changed
    if (prevProps.data !== this.props.data) {
      this.setState({
        data: this.props.data,
        range: 0,
        characteristic: 0
      });

    }
  }


  handleChangeItem = event => {
    this.setState({ [event.target.name]: event.target.value });
  };


  getTotal = () => {
    const { data } = this.props;
    let resp = 0;
    for (let i = 0; i < data.length; i++) {
      resp += data[i].value;
    }
    return resp;
  }

  getItems = () => {
    return this.state.data.map((val, i) => {
      return (
        <MenuItem value={i}>{val.name}</MenuItem>
      )
    })
  }

  changeCharacteristics = (val) => {
    if (typeof this.props.data[val.target.value] !== "undefined") {
      this.setState({ data: [this.props.data[val.target.value]] });
    } else {
      let datos = [];
      if (this.props.data.length > 4) {
        for (let i = 0; i < 5; i++) {
          datos.push(this.props.data[i]);
        }
      } else {
        datos = this.props.data;
      }
      this.setState({ data: datos });
    }
  }
  onChangeColor = (color) => {
    if (color === 'Verde') {
      this.setState({ colors: colors })
    } else if (color === 'Rojo') {
      this.setState({ colors: colors1 })
    } else if (color === 'Verde-Azul') {
      this.setState({ colors: colors2 })
    } else if (color === 'Gris') {
      this.setState({ colors: colors3 })
    } else if (color === 'Azul') {
      this.setState({ colors: colors4 })
    }
  }

  changeTops = (val) => {
    var top = [];
    for (let i = val.target.value * 5; i < (val.target.value * 5) + 5; i++) {
      try {
        top.push(this.props.data[i]);
      } catch (e) { }
    }
    this.setState({ data: top });
  }
  // getTotal = () => {
  //   const { data } = this.props;
  //   let resp = 0;
  //   for (let i = 0; i < data.length; i++) {
  //     resp += data[i].value;
  //   }
  //   return resp;
  // }

  changeDataKey = () => {
    if (this.state.dataKey === 'value') {
      this.setState({ dataKey: 'rate', lineKey: 'medRate', title: 'Tasa por Comuna' })
    } else {
      this.setState({ dataKey: 'value', lineKey: 'medVal', title: 'Fenomeno por Comuna' })
    }
  }

  render() {
    return (
      <Grid style={{ flexWrap: "inherit", width: '100%' }} id={this.props.name} >
        <ChartMenu
          graph={this.props.name}
          file={this.props.title}
          title={this.state.title}
          watch={this.props.watchMenu}
          changeColor={true}
          onChangeColor={this.onChangeColor}
          openDialog={this.props.openDialog}
          seeMore={this.props.seeMore}
          seeRate={this.props.seeRate}
          dataKey={this.state.dataKey}
          changeRate={this.changeDataKey}
        />
        <Grid container>
          <Grid item xs={12}>
            <p style={{textAlign:'center'}}>{'Total: ' + this.getTotal()}</p>
          </Grid>
          <Grid item xs={12} style={{ height: '250px' }}>
            {
              <BarsComponent
                data={this.state.data}
                onClickGraphic={this.props.onClickGraphic}
                name={this.props.name}
                colors={this.state.colors}
                total={this.getTotal()}
                dataKey={this.state.dataKey}
                lineKey={this.state.lineKey}
                />
            }
          </Grid>
        </Grid>

      </Grid>
    )
  }
}

export default CleanBarComponent; 